import { VestingCard } from '@dealstack/frontend/shared/components/VestingCard/VestingCard.tsx';
import { IconOutbound } from '@tabler/icons-react';
import { LeaverProvisions } from '@dealstack/frontend/shared/components/VestingTerms/LeaverProvisions.tsx';
import { NumberInput } from '@dealstack/frontend/shared/components/NumberInput/NumberInput.tsx';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useVestingTermsContext } from '@dealstack/frontend/shared/components/VestingTerms/VestingTermsContext.tsx';
import { orderBy } from 'lodash';
import { memo, useEffect, useMemo, useState } from 'react';

export const LeaverProvisionsWrapper = memo(() => {
	const tCommonUi = useTranslationCommonUi();

	const {
		currentVestingTerm,
		handleOptionPeriodUpdate,
		onCreateVestingTermLeaverProvision,
		onUpdateVestingTermLeaverProvision,
		onDeleteVestingTermLeaverProvision,
	} = useVestingTermsContext();

	const [optionPeriodError, setOptionPeriodError] = useState<string>();
	const [leaverProvisionCreatorOpen, setLeaverProvisionCreatorOpen] = useState<boolean>(false);

	useEffect(() => {
		setOptionPeriodError(undefined);
	}, [currentVestingTerm.id]);

	const sortedLeaverProvisions = useMemo(
		() => orderBy(currentVestingTerm.vestingTermLeaverProvisions, 'createdAt'),
		[currentVestingTerm.vestingTermLeaverProvisions]
	);

	return (
		<VestingCard
			title={tCommonUi('vesting_terms.leaver_title')}
			titleSize="lg"
			titleWeight={800}
			icon={<IconOutbound stroke={2} size={24} />}
		>
			<LeaverProvisions
				vestingTermId={currentVestingTerm.id}
				leaverProvisions={sortedLeaverProvisions}
				leaverProvisionCreatorOpen={leaverProvisionCreatorOpen}
				setLeaverProvisionCreatorOpen={setLeaverProvisionCreatorOpen}
				onCreateVestingTermLeaverProvision={onCreateVestingTermLeaverProvision}
				onUpdateVestingTermLeaverProvision={onUpdateVestingTermLeaverProvision}
				onDeleteVestingTermLeaverProvision={onDeleteVestingTermLeaverProvision}
			/>

			<div className="font-semibold mt-4 text-sm">
				{tCommonUi('vesting_terms.option_period_label')}
			</div>

			<NumberInput
				name="optionPeriod"
				inputPlaceholder=""
				inputId={currentVestingTerm.id}
				value={currentVestingTerm.optionPeriod}
				onChange={(value) => {
					const { error } = handleOptionPeriodUpdate(currentVestingTerm.id, value);
					setOptionPeriodError(error ?? undefined);
				}}
				getDisplayUnit={(value) => {
					return value === 1
						? ` ${tCommonUi('vesting_terms.month')}`
						: ` ${tCommonUi('vesting_terms.months')}`;
				}}
				errorMessage={optionPeriodError}
			/>

			<div className="mt-1 text-sm">
				{tCommonUi('vesting_terms.option_period_description')}
			</div>
		</VestingCard>
	);
});
